import { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { getZipCodeFromCookie, setZipCodeCookie } from "services/zipCode";
import { ZipCodeContextInterface } from "context/zipCode";
import client from "services/graphql/client";
import {
  RestrictedItemsByZipCodeDocument,
  RestrictedItemsByZipCodeQuery,
  RestrictedItemsByZipCodeQueryVariables,
} from "services/graphql/generated";

export function useZipCodeProvider(): {
  zipCodeContextValue: ZipCodeContextInterface;
} {
  const [zipCode, setZipCode] = useState<string | null>(null);
  const [blockedItems, setBlockedItems] = useState<
    NonNullable<
      NonNullable<
        RestrictedItemsByZipCodeQuery["restrictedItemsByZipCode"]
      >["restrictedItems"]
    >
  >([]);
  const [getRestrictedItems] = useLazyQuery<
    RestrictedItemsByZipCodeQuery,
    RestrictedItemsByZipCodeQueryVariables
  >(RestrictedItemsByZipCodeDocument, { client });

  useEffect(() => {
    const acquireZip = async () => {
      const cookieZip = getZipCodeFromCookie();
      if (cookieZip) {
        setZipCode(cookieZip);
        return;
      }
    };

    const getBlockedItems = async () => {
      try {
        const { data } = await getRestrictedItems({
          variables: { zip: zipCode || "" },
        });
        const items = data?.restrictedItemsByZipCode?.restrictedItems || [];
        setBlockedItems(items);
      } catch (e) {
        // logged in errorLink
      }
    };

    if (zipCode) {
      getBlockedItems();
    } else {
      acquireZip();
    }
  }, [zipCode, getRestrictedItems]);

  const zipCodeContextValue: ZipCodeContextInterface = {
    zipCode,
    userSetZipCode: (zip: string) => {
      setZipCode(zip);
      setZipCodeCookie(zip);
    },
    blockedItems: blockedItems.map(({ id }) => id),
  };

  return { zipCodeContextValue };
}
